module.exports = require("@ember/application/instance");